var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailabilityCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 98.75,
    height: 82.0579,
    viewBox: "0 0 98.75 82.0579",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 17.3592L86.1176 0.544789L98.75 65.2434L12.6324 82.0579L0 17.3592Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M96.8452 64.319L85.2062 66.5921C81.2979 66.0312 15.5006 78.5873 15.5006 78.5873L3.61328 19.2571L23.6424 14.0409L84.7008 2.11853L96.8452 64.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.59045 18.5188L5.28574 18.7735C5.03894 18.8217 4.87793 19.0609 4.92612 19.3077L5.23322 20.8805C5.28141 21.1273 5.52055 21.2883 5.76735 21.2402L7.07206 20.9854C7.31886 20.9372 7.47987 20.6981 7.43168 20.4513L7.12457 18.8784C7.07638 18.6316 6.83725 18.4706 6.59045 18.5188Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.55011 20.008C5.45196 20.008 5.36427 19.9387 5.34473 19.8387L4.4302 15.1552C4.408 15.0417 4.48214 14.9316 4.59565 14.9094C4.70916 14.8868 4.81919 14.9614 4.84139 15.0749L5.75591 19.7584C5.77811 19.8719 5.70398 19.9819 5.59046 20.0041C5.57692 20.0068 5.56338 20.008 5.55011 20.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.72931 19.7778C6.63116 19.7778 6.54347 19.7084 6.52393 19.6084L5.6094 14.9248C5.5872 14.8113 5.66134 14.7012 5.77485 14.679C5.88836 14.6564 5.99839 14.731 6.02059 14.8445L6.93511 19.5281C6.95731 19.6416 6.88317 19.7517 6.76966 19.7739C6.75612 19.7765 6.74257 19.7778 6.72931 19.7778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.1075 17.0512L12.8028 17.3059C12.556 17.3541 12.395 17.5933 12.4432 17.8401L12.7503 19.413C12.7985 19.6598 13.0376 19.8208 13.2844 19.7726L14.5891 19.5178C14.8359 19.4696 14.997 19.2305 14.9488 18.9837L14.6417 17.4108C14.5935 17.164 14.3543 17.003 14.1075 17.0512Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.0671 18.5405C12.969 18.5405 12.8813 18.4711 12.8617 18.3711L11.9472 13.6875C11.925 13.574 11.9991 13.4639 12.1127 13.4417C12.2262 13.4191 12.3362 13.4937 12.3584 13.6072L13.2729 18.2908C13.2951 18.4043 13.221 18.5144 13.1075 18.5366C13.0939 18.5392 13.0804 18.5405 13.0671 18.5405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.2464 18.3101C14.1482 18.3101 14.0606 18.2407 14.041 18.1407L13.1265 13.4572C13.1043 13.3437 13.1784 13.2337 13.2919 13.2115C13.4056 13.1887 13.5155 13.2634 13.5377 13.3769L14.4522 18.0604C14.4744 18.174 14.4003 18.284 14.2868 18.3062C14.2732 18.3088 14.2597 18.3101 14.2464 18.3101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M21.6222 15.5839L20.3175 15.8387C20.0707 15.8868 19.9097 16.126 19.9579 16.3728L20.265 17.9457C20.3132 18.1925 20.5523 18.3535 20.7991 18.3053L22.1038 18.0505C22.3506 18.0024 22.5116 17.7632 22.4634 17.5164L22.1563 15.9435C22.1081 15.6967 21.869 15.5357 21.6222 15.5839Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M20.5818 17.0729C20.4837 17.0729 20.396 17.0035 20.3765 16.9035L19.4619 12.22C19.4397 12.1065 19.5139 11.9965 19.6274 11.9743C19.741 11.9515 19.8509 12.0262 19.8731 12.1398L20.7877 16.8233C20.8099 16.9368 20.7357 17.0468 20.6222 17.069C20.6087 17.0716 20.5951 17.0729 20.5818 17.0729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M21.7635 16.8425C21.6653 16.8425 21.5777 16.7731 21.5581 16.6731L20.6436 11.9896C20.6214 11.8761 20.6955 11.7661 20.809 11.7439C20.9225 11.7211 21.0326 11.7958 21.0548 11.9093L21.9693 16.5929C21.9915 16.7064 21.9174 16.8164 21.8038 16.8386C21.7903 16.8412 21.7768 16.8425 21.7635 16.8425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M29.1393 14.1161L27.8346 14.3709C27.5878 14.4191 27.4268 14.6582 27.4749 14.905L27.7821 16.4779C27.8302 16.7247 28.0694 16.8857 28.3162 16.8375L29.6209 16.5828C29.8677 16.5346 30.0287 16.2954 29.9805 16.0486L29.6734 14.4758C29.6252 14.229 29.3861 14.068 29.1393 14.1161Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M28.099 15.6053C28.0009 15.6053 27.9132 15.5359 27.8936 15.4359L26.9791 10.7524C26.9569 10.6389 27.031 10.5289 27.1445 10.5067C27.2581 10.4839 27.3681 10.5586 27.3903 10.6721L28.3048 15.3556C28.327 15.4692 28.2529 15.5792 28.1394 15.6014C28.1258 15.604 28.1123 15.6053 28.099 15.6053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M29.2781 15.3751C29.18 15.3751 29.0923 15.3057 29.0728 15.2057L28.1582 10.5222C28.136 10.4087 28.2102 10.2987 28.3237 10.2765C28.4372 10.2542 28.5472 10.3284 28.5694 10.4419L29.4839 15.1254C29.5061 15.239 29.432 15.349 29.3185 15.3712C29.3049 15.3738 29.2914 15.3751 29.2781 15.3751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M36.6564 12.6487L35.3517 12.9035C35.1049 12.9517 34.9438 13.1908 34.992 13.4376L35.2991 15.0105C35.3473 15.2573 35.5865 15.4183 35.8333 15.3701L37.138 15.1154C37.3848 15.0672 37.5458 14.828 37.4976 14.5812L37.1905 13.0084C37.1423 12.7616 36.9032 12.6005 36.6564 12.6487Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M35.6159 14.1379C35.5177 14.1379 35.4301 14.0685 35.4105 13.9685L34.4961 9.28505C34.4739 9.17153 34.5481 9.06151 34.6616 9.03931C34.7751 9.01697 34.8851 9.09125 34.9073 9.20476L35.8217 13.8883C35.8439 14.0018 35.7698 14.1118 35.6562 14.134C35.6427 14.1367 35.6292 14.1379 35.6159 14.1379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M36.795 13.9075C36.6968 13.9075 36.6091 13.8381 36.5896 13.7381L35.675 9.05464C35.6528 8.94113 35.727 8.8311 35.8405 8.8089C35.9541 8.78657 36.064 8.86084 36.0862 8.97436L37.0008 13.6579C37.023 13.7714 36.9488 13.8814 36.8353 13.9036C36.8218 13.9062 36.8082 13.9075 36.795 13.9075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M44.1712 11.1812L42.8665 11.436C42.6197 11.4842 42.4587 11.7233 42.5068 11.9701L42.8139 13.543C42.8621 13.7898 43.1013 13.9508 43.3481 13.9026L44.6528 13.6478C44.8996 13.5997 45.0606 13.3605 45.0124 13.1137L44.7053 11.5408C44.6571 11.294 44.418 11.133 44.1712 11.1812Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M43.1307 12.6703C43.0325 12.6703 42.9448 12.6009 42.9253 12.501L42.0108 7.81746C41.9886 7.70394 42.0627 7.59392 42.1762 7.57172C42.2899 7.54938 42.3998 7.62366 42.422 7.73717L43.3365 12.4207C43.3587 12.5342 43.2845 12.6442 43.171 12.6664C43.1575 12.6691 43.1439 12.6703 43.1307 12.6703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M44.3099 12.44C44.2117 12.44 44.124 12.3706 44.1045 12.2706L43.19 7.58709C43.1678 7.47357 43.2419 7.36355 43.3554 7.34135C43.4689 7.31887 43.5789 7.39329 43.6011 7.5068L44.5157 12.1903C44.5379 12.3038 44.4637 12.4138 44.3502 12.436C44.3367 12.4387 44.3231 12.44 44.3099 12.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M51.6881 9.71385L50.3834 9.9686C50.1366 10.0168 49.9756 10.2559 50.0238 10.5027L50.3309 12.0756C50.3791 12.3224 50.6182 12.4834 50.865 12.4352L52.1697 12.1805C52.4165 12.1323 52.5775 11.8932 52.5293 11.6464L52.2222 10.0735C52.174 9.82667 51.9349 9.66567 51.6881 9.71385Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M50.6475 11.203C50.5494 11.203 50.4617 11.1336 50.4421 11.0336L49.5276 6.35013C49.5054 6.23662 49.5795 6.1266 49.6931 6.1044C49.8066 6.08192 49.9166 6.15634 49.9388 6.26985L50.8533 10.9534C50.8755 11.0669 50.8014 11.1769 50.6879 11.1991C50.6743 11.2017 50.6608 11.203 50.6475 11.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M51.8268 10.9727C51.7287 10.9727 51.641 10.9033 51.6214 10.8033L50.7071 6.1198C50.6849 6.00629 50.759 5.89627 50.8725 5.87407C50.986 5.85159 51.096 5.92601 51.1182 6.03952L52.0326 10.723C52.0548 10.8365 51.9807 10.9466 51.8672 10.9688C51.8536 10.9714 51.8401 10.9727 51.8268 10.9727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M59.2028 8.24596L57.898 8.5007C57.6512 8.54889 57.4902 8.78803 57.5384 9.03483L57.8455 10.6077C57.8937 10.8545 58.1329 11.0155 58.3797 10.9673L59.6844 10.7126C59.9312 10.6644 60.0922 10.4253 60.044 10.1785L59.7369 8.60558C59.6887 8.35878 59.4496 8.19777 59.2028 8.24596Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M58.1624 9.73548C58.0643 9.73548 57.9766 9.66609 57.957 9.56612L57.0425 4.88262C57.0203 4.76911 57.0944 4.65908 57.208 4.63688C57.3216 4.6144 57.4315 4.68882 57.4537 4.80234L58.3682 9.48584C58.3904 9.59935 58.3163 9.70937 58.2028 9.73157C58.1892 9.73423 58.1757 9.73548 58.1624 9.73548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M59.3441 9.50522C59.2459 9.50522 59.1582 9.43582 59.1387 9.33585L58.2241 4.65221C58.2019 4.5387 58.2761 4.42868 58.3896 4.40648C58.5032 4.384 58.6131 4.45842 58.6353 4.57193L59.5499 9.25557C59.5721 9.36908 59.4979 9.47911 59.3844 9.50131C59.3709 9.50396 59.3573 9.50522 59.3441 9.50522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M66.7198 6.77867L65.4151 7.03342C65.1683 7.08161 65.0073 7.32074 65.0555 7.56754L65.3626 9.14043C65.4108 9.38723 65.6499 9.54824 65.8967 9.50005L67.2015 9.2453C67.4483 9.19712 67.6093 8.95798 67.5611 8.71118L67.254 7.13829C67.2058 6.89149 66.9666 6.73049 66.7198 6.77867Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M65.6794 8.26791C65.5813 8.26791 65.4936 8.19851 65.474 8.09854L64.5595 3.41504C64.5373 3.30153 64.6114 3.19151 64.7249 3.16931C64.8386 3.14683 64.9485 3.22125 64.9707 3.33476L65.8852 8.01826C65.9074 8.13177 65.8333 8.2418 65.7198 8.264C65.7062 8.26665 65.6927 8.26791 65.6794 8.26791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M66.8587 8.03752C66.7605 8.03752 66.6729 7.96813 66.6533 7.86816L65.7388 3.18466C65.7166 3.07115 65.7907 2.96112 65.9042 2.93892C66.0178 2.91631 66.1278 2.99086 66.15 3.10438L67.0645 7.78788C67.0867 7.90139 67.0126 8.01141 66.8991 8.03361C66.8855 8.03627 66.872 8.03752 66.8587 8.03752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M74.2345 5.31108L72.9298 5.56583C72.683 5.61402 72.522 5.85315 72.5702 6.09995L72.8773 7.67284C72.9255 7.91964 73.1646 8.08065 73.4114 8.03246L74.7161 7.77771C74.9629 7.72953 75.1239 7.49039 75.0757 7.24359L74.7686 5.6707C74.7204 5.4239 74.4813 5.2629 74.2345 5.31108Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M73.1942 6.80034C73.096 6.80034 73.0083 6.73095 72.9888 6.63098L72.0742 1.94748C72.052 1.83396 72.1262 1.72394 72.2397 1.70174C72.3532 1.67912 72.4632 1.75368 72.4854 1.8672L73.4 6.5507C73.4222 6.66421 73.348 6.77423 73.2345 6.79643C73.221 6.79909 73.2074 6.80034 73.1942 6.80034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M74.3758 6.56993C74.2776 6.56993 74.19 6.50054 74.1704 6.40057L73.2559 1.71707C73.2337 1.60356 73.3078 1.49353 73.4213 1.47133C73.5348 1.44872 73.6449 1.52327 73.6671 1.63679L74.5816 6.32029C74.6038 6.4338 74.5297 6.54383 74.4161 6.56603C74.4026 6.56868 74.3891 6.56993 74.3758 6.56993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M81.7516 3.84358L80.4469 4.09832C80.2001 4.14651 80.039 4.38565 80.0872 4.63245L80.3943 6.20533C80.4425 6.45213 80.6817 6.61314 80.9285 6.56495L82.2332 6.31021C82.48 6.26202 82.641 6.02289 82.5928 5.77609L82.2857 4.2032C82.2375 3.9564 81.9984 3.79539 81.7516 3.84358Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M80.7113 5.33286C80.6131 5.33286 80.5255 5.26346 80.5059 5.16349L79.5914 0.479992C79.5692 0.366478 79.6433 0.256456 79.7568 0.234256C79.8705 0.211637 79.9804 0.286195 80.0026 0.399709L80.9171 5.08321C80.9393 5.19672 80.8652 5.30675 80.7516 5.32895C80.7381 5.3316 80.7246 5.33286 80.7113 5.33286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M81.8904 5.10253C81.7923 5.10253 81.7046 5.03314 81.6851 4.93317L80.7705 0.249668C80.7483 0.136155 80.8225 0.0261325 80.936 0.00393247C81.0496 -0.0182675 81.1595 0.0558721 81.1817 0.169385L82.0962 4.85289C82.1184 4.9664 82.0443 5.07642 81.9308 5.09862C81.9173 5.10128 81.9037 5.10253 81.8904 5.10253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M34.9536 23.6161L34.9718 23.7125L34.3016 23.14L35.5498 22.9055L35.6587 23.4835L34.9536 23.6161Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M35.3195 25.5568L34.74 25.6657L34.3742 23.725L33.732 23.8464L33.623 23.2684L34.3016 23.14L34.9718 23.7124L35.3195 25.5568Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M56.9622 21.3314L56.3835 21.4405L56.018 19.4996L55.3753 19.6207L55.2661 19.0418L57.1936 18.6789L57.3026 19.2576L56.5966 19.3907L56.962 21.3314H56.9622Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M67.2168 18.9169L66.6381 19.0258L66.5803 18.7195C66.4901 18.2409 66.8062 17.778 67.285 17.688L67.7397 17.6022L67.8486 18.181L67.3939 18.2667C67.2343 18.2967 67.1289 18.451 67.159 18.6106L67.2168 18.9169Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M67.291 19.3127L66.7123 19.4216L66.2378 16.9019L67.8697 16.5946L67.9786 17.1734L66.9255 17.3718L67.291 19.3127Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M24.5343 27.661L23.9556 27.7699L23.6312 26.0473C23.6086 25.927 23.4923 25.8475 23.3721 25.8702L22.8263 25.973L23.1864 27.8848L22.6077 27.9937L22.1387 25.503L23.2632 25.2912C23.7024 25.2084 24.1275 25.4987 24.2101 25.9381L24.5345 27.6607L24.5343 27.661Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M25.8909 27.405L25.3122 27.5139L24.9879 25.7912C24.9653 25.671 24.8489 25.5914 24.7287 25.6142L24.4535 25.666C24.3044 25.6941 24.2058 25.8383 24.2339 25.9876L24.5429 27.6288L23.9642 27.7377L23.6552 26.0965C23.5669 25.6282 23.8762 25.1754 24.3446 25.0873L24.6198 25.0355C25.0592 24.9527 25.4841 25.2429 25.5667 25.6823L25.8909 27.405Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M47.525 23.1811L46.4005 23.3929C45.9611 23.4757 45.5363 23.1855 45.4537 22.7461L45.1294 21.0233L45.7081 20.9144L46.0325 22.6372C46.0551 22.7575 46.1714 22.8369 46.2916 22.8141L46.8374 22.7114L46.4773 20.7995L47.056 20.6906L47.525 23.1811Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M45.318 23.5968L45.0428 23.6486C44.6036 23.7314 44.1786 23.4412 44.096 23.0018L43.7717 21.279L44.3504 21.1701L44.6748 22.8929C44.6974 23.0131 44.8137 23.0926 44.9339 23.0698L45.2091 23.018C45.3582 22.99 45.4568 22.8457 45.4287 22.6966L45.1197 21.0553L45.6985 20.9464L46.0075 22.5877C46.0956 23.0559 45.7863 23.5087 45.318 23.5968Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M13.6478 30.0187L12.5512 30.225L12.4423 29.6463L13.5389 29.4399C13.6591 29.4173 13.7387 29.301 13.7159 29.1808L13.7081 29.1395C13.6855 29.0193 13.5692 28.9398 13.449 28.9626L12.2978 29.1794L12.1601 28.4482C12.0773 28.009 12.3676 27.5841 12.807 27.5013L13.8769 27.2998L13.9858 27.8785L12.9159 28.08C12.7957 28.1026 12.7162 28.2188 12.7388 28.3392L12.7676 28.4916L13.3401 28.3838C13.7793 28.301 14.2043 28.5912 14.2868 29.0306L14.2947 29.0719C14.3772 29.5112 14.087 29.9359 13.6478 30.0187Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M78.5379 17.1491L77.4413 17.3555L77.3324 16.7767L78.429 16.5704C78.5492 16.5478 78.6288 16.4315 78.6061 16.3112L78.5982 16.2699C78.5756 16.1497 78.4593 16.0702 78.3391 16.093L77.1879 16.3098L77.0502 15.5786C76.9674 15.1392 77.2577 14.7145 77.6971 14.6317L78.767 14.4302L78.8759 15.009L77.806 15.2105C77.6858 15.2331 77.6064 15.3492 77.629 15.4696L77.6577 15.6221L78.2302 15.5143C78.6694 15.4315 79.0945 15.7216 79.177 16.161L79.1848 16.2023C79.2674 16.6414 78.9773 17.0663 78.5379 17.1491Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M82.059 63.9071L17.02 76.6058L7.45584 27.6248L33.5792 22.5243L33.4438 22.4085L7.3609 27.5005L7.29248 27.5145L16.8957 76.7007L16.9097 76.7691L82.1944 64.023L82.059 63.9071Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M92.7984 61.9521L92.73 61.9661L82.1955 64.0227L82.06 63.9069L92.6337 61.8418L83.0709 12.8608L33.5803 22.5241L33.4448 22.4082L83.1812 12.6975L83.1938 12.7659L92.7984 61.9521Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M83.9546 17.0272L37.7172 26.0552L37.4463 25.8234L83.9015 16.7535L83.9546 17.0272Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M37.7159 26.0551L8.20387 31.8174L8.14941 31.5437L37.445 25.8234L37.7159 26.0551Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M9.87994 40.7638L8.0957 31.6253L8.16426 31.6118L19.0543 29.4855L20.8385 38.6239L20.7699 38.6375L9.87994 40.7638ZM8.25948 31.7355L9.99024 40.5999L20.6747 38.5139L18.944 29.6495L8.25948 31.7355Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M20.7003 38.6507L18.916 29.5123L18.9846 29.4988L29.8746 27.3724L31.6588 36.5109L31.5903 36.5244L20.7003 38.6507ZM19.0798 29.6225L20.8106 38.4868L31.495 36.4009L29.7643 27.5365L19.0798 29.6225Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M41.481 29.268L41.3093 29.1214L42.3174 34.2874L31.6334 36.3734L29.9021 27.5101L37.6498 25.998L37.513 25.8807L29.8072 27.3859L29.7388 27.3998L31.5231 36.5381L42.4123 34.4117L42.4821 34.3977L41.481 29.268Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M41.4803 29.268L41.3085 29.1214L40.5867 25.4242L37.649 25.998L37.5122 25.8807L40.697 25.2594L41.4803 29.268Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M46.423 33.4859L42.4549 34.2608L41.4803 29.2665L41.31 29.1213L41.3086 29.1199L42.3446 34.4255L46.5598 33.6032L46.423 33.4859Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M53.3025 32.2852L53.2341 32.2991L46.5588 33.6032L46.4219 33.4859L53.1392 32.1749L51.4079 23.3102L40.7239 25.3962L41.4793 29.2665L41.309 29.1213L41.3076 29.1199L40.5592 25.2859L40.629 25.2733L51.5182 23.1469L53.3025 32.2852Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M53.1661 32.3121L51.3818 23.1738L51.4504 23.1603L62.3404 21.0339L64.1246 30.1724L64.0561 30.1859L53.1661 32.3121ZM51.5456 23.284L53.2764 32.1482L63.9609 30.0622L62.2301 21.1979L51.5456 23.284Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M63.9864 30.1992L62.2021 21.0608L62.2707 21.0472L73.1608 18.9209L74.9451 28.0593L74.8765 28.0729L63.9865 30.1992H63.9864ZM62.3659 21.1709L64.0967 30.0353L74.7812 27.9493L73.0504 19.085L62.3659 21.1709Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M74.8091 28.0862L73.0249 18.9477L73.0935 18.9342L83.9835 16.8079L85.7677 25.9463L85.6992 25.9599L74.8091 28.0862ZM73.1887 19.0579L74.9194 27.9222L85.6039 25.8363L83.8732 16.9719L73.1887 19.0579Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M11.6378 49.7649L9.85352 40.6265L9.92207 40.613L20.8122 38.4866L22.5965 47.6251L22.5279 47.6386L11.6378 49.7649ZM10.0173 40.7367L11.7481 49.601L22.4325 47.5151L20.7018 38.6507L10.0173 40.7367Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M22.4581 47.6522L20.6738 38.5138L20.7424 38.5002L31.6324 36.3739L33.4166 45.5122L33.3481 45.5258L22.4581 47.6521V47.6522ZM20.8376 38.6239L22.5684 47.4883L33.2529 45.4022L31.5221 36.538L20.8376 38.6239Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M33.2808 45.5393L31.4966 36.401L31.5651 36.3875L42.4551 34.2612L44.2394 43.3995L44.1708 43.413L33.2808 45.5393ZM31.6604 36.5112L33.3911 45.3754L44.0756 43.2895L42.3448 34.4252L31.6604 36.5112Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M54.96 40.773L54.791 40.6292L54.8971 41.1765L44.2118 43.2625L42.4819 34.3978L46.5575 33.602L46.422 33.4861L42.3855 34.2749L42.3171 34.2875L44.1015 43.4258L54.9921 41.3008L55.0605 41.2868L54.96 40.773Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M54.9613 40.7729L54.7923 40.6291H54.7909L53.1671 32.3118L46.5588 33.6019L46.4233 33.486L53.2774 32.1484L54.9613 40.7729Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M55.3318 41.0914L55.0344 41.1501L54.9618 40.7745L54.79 40.6293L54.9241 41.3134L55.4672 41.2073L55.3318 41.0914Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M65.8816 39.1742L65.8132 39.1868L55.4672 41.2071L55.3317 41.0912L65.7183 39.0639L63.9869 30.1992L53.303 32.2852L54.9617 40.7743L54.79 40.6291L53.1396 32.1749L53.2081 32.1609L64.0972 30.0345L65.8816 39.1742Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M65.7444 39.2004L63.9602 30.062L64.0288 30.0484L74.9188 27.9221L76.703 37.0606L76.6345 37.0741L65.7443 39.2004H65.7444ZM64.124 30.1721L65.8547 39.0365L76.5392 36.9505L74.8085 28.0862L64.124 30.1721Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M76.567 37.0876L74.7827 27.9492L74.8513 27.9356L85.7413 25.8093L87.5255 34.9478L87.457 34.9613L76.567 37.0876ZM74.9465 28.0593L76.6773 36.9237L87.3617 34.8377L85.631 25.9734L74.9465 28.0593Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M13.3956 58.7663L11.6113 49.628L11.6799 49.6144L22.5699 47.4881L24.3541 56.6264L24.2856 56.6399L13.3956 58.7663ZM11.7751 49.7381L13.5059 58.6023L24.1904 56.5164L22.4596 47.6522L11.7751 49.7381Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M24.2159 56.6535L22.4316 47.5152L22.5002 47.5017L33.3902 45.3754L35.1744 54.5138L35.1059 54.5274L24.2159 56.6537V56.6535ZM22.5954 47.6254L24.3262 56.4896L35.0107 54.4037L33.2799 45.5393L22.5954 47.6254Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M35.0386 54.5406L33.2544 45.4022L33.3229 45.3886L44.213 43.2623L45.9972 52.4008L45.9286 52.4143L35.0386 54.5406ZM33.4182 45.5124L35.1489 54.3767L45.8334 52.2908L44.1027 43.4264L33.4182 45.5124Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M45.8589 52.4279L44.0747 43.2895L44.1433 43.2759L55.0333 41.1496L56.8175 50.288L56.749 50.3016L45.8589 52.4279ZM44.2385 43.3996L45.9692 52.264L56.6537 50.178L54.923 41.3137L44.2385 43.3996Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M64.2408 48.6965L56.7906 50.1514L55.0606 41.2867L55.4669 41.2071L55.3315 41.0913L54.9657 41.1625L54.8973 41.1764L56.6803 50.3147L64.3763 48.8124L64.2408 48.6965Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M67.6398 48.1757L67.5714 48.1882L64.3768 48.8123L64.2414 48.6964L67.4764 48.0654L65.7451 39.2007L55.4675 41.2071L55.332 41.0912L65.8554 39.036L67.6398 48.1757Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M67.502 48.2018L65.7178 39.0634L65.7863 39.0498L76.6765 36.9235L78.4607 46.062L78.3922 46.0755L67.5022 48.2018H67.502ZM65.8815 39.1735L67.6123 48.0379L78.2968 45.9519L76.566 37.0876L65.8815 39.1735Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M78.3248 46.0891L76.5405 36.9506L76.6091 36.9371L87.4991 34.8108L89.2833 43.9492L89.2148 43.9628L78.3248 46.0891ZM76.7043 37.0608L78.4351 45.9252L89.1196 43.8392L87.3888 34.9748L76.7043 37.0608Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M15.1534 67.7679L13.3691 58.6294L13.4377 58.6159L24.3278 56.4896L26.1121 65.628L26.0435 65.6416L15.1534 67.7679ZM13.5329 58.7396L15.2637 67.6039L25.9482 65.518L24.2174 56.6536L13.5329 58.7396Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M25.9735 65.6549L24.1893 56.5164L24.2578 56.5029L35.1478 54.3766L36.9321 63.515L36.8635 63.5286L25.9735 65.6549ZM24.353 56.6266L26.0838 65.491L36.7683 63.405L35.0375 54.5406L24.353 56.6266Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M36.794 63.5421L35.0098 54.4037L35.0783 54.3901L45.9683 52.2638L47.7526 61.4022L47.684 61.4158L36.794 63.5421ZM35.1735 54.5138L36.9043 63.3782L47.5888 61.2922L45.858 52.4279L35.1735 54.5138Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M47.6166 61.4291L45.8323 52.2907L45.9009 52.2772L56.7909 50.1508L58.5751 59.2893L58.5066 59.3028L47.6166 61.4291ZM45.9961 52.4009L47.7269 61.2652L58.4114 59.1793L56.6806 50.3149L45.9961 52.4009Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M68.4412 52.2818L68.2694 52.1366L69.2328 57.0667L58.5475 59.1526L56.8176 50.288L64.3754 48.8122L64.2399 48.6963L56.7213 50.1637L56.6528 50.1777L58.4372 59.316L69.3278 57.1895L69.3962 57.177L68.4412 52.2818Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M68.4421 52.282L68.2703 52.1368L67.5024 48.2022L64.3762 48.8124L64.2408 48.6965L67.6127 48.0375L68.4421 52.282Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M73.1513 56.3018L69.3717 57.039L68.4432 52.2821L68.4418 52.2807L68.2715 52.1368L69.2614 57.2038L73.2881 56.4177L73.1513 56.3018Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M80.2175 55.0633L80.1491 55.0773L73.2867 56.4176L73.1498 56.3017L80.0542 54.953L78.3243 46.0897L67.6389 48.1757L68.4404 52.2806L68.27 52.1368L67.4756 48.0654L67.544 48.0514L78.4346 45.925L80.2175 55.0633Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M80.0801 55.0906L78.2959 45.9521L78.3645 45.9386L89.2545 43.8123L91.0387 52.9507L90.9701 52.9642L80.0801 55.0906ZM78.4597 46.0623L80.1904 54.9266L90.8749 52.8407L89.1442 43.9763L78.4597 46.0623Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M16.9087 76.7694L15.1244 67.631L15.193 67.6175L26.083 65.4911L27.8672 74.6296L27.7987 74.6431L16.9087 76.7694ZM15.2882 67.7412L17.019 76.6055L27.7034 74.5196L25.9727 65.6552L15.2882 67.7412Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M27.7291 74.6566L25.9448 65.5182L26.0134 65.5046L36.9034 63.3783L38.6876 72.5167L38.6191 72.5303L27.7291 74.6566ZM26.1086 65.6283L27.8394 74.4927L38.5238 72.4067L36.7931 63.5424L26.1086 65.6283Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M38.5517 72.5437L36.7675 63.4053L36.8361 63.3917L47.7261 61.2654L49.5103 70.4038L49.4418 70.4174L38.5517 72.5437ZM36.9313 63.5154L38.662 72.3798L49.3465 70.2938L47.6158 61.4295L36.9313 63.5154Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M49.3721 70.4308L47.5879 61.2924L47.6564 61.2788L58.5465 59.1525L60.3307 68.291L60.2621 68.3045L49.3721 70.4308ZM47.7517 61.4026L49.4824 70.2669L60.1669 68.181L58.4362 59.3166L47.7517 61.4026Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M60.1948 68.3178L58.4106 59.1793L58.4791 59.1658L69.3692 57.0395L71.1534 66.1779L71.0848 66.1915L60.1948 68.3178ZM58.5744 59.2895L60.3051 68.1539L70.9896 66.0679L69.2589 57.2035L58.5744 59.2895Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M81.9199 63.7898L81.7495 63.6446L81.8096 63.9546L71.1256 66.0406L69.3943 57.1773L73.2842 56.4178L73.1474 56.3019L69.2994 57.0531L69.231 57.067L71.0153 66.2053L81.9045 64.0789L81.9729 64.0649L81.9199 63.7898Z",
    fill: "#1D72F4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M81.9222 63.7897L81.7519 63.6444L80.0806 55.0912L73.2865 56.4176L73.1497 56.3017L80.1909 54.9264L81.9222 63.7897Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M82.0601 63.9069L81.9498 63.9278L81.9233 63.7896L81.7529 63.6444L81.8395 64.0912L82.1941 64.0214L82.0601 63.9069Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M92.7971 61.9523L92.7287 61.9663L82.1927 64.0215L82.0587 63.9071L92.6323 61.842L90.9024 52.9774L80.2171 55.0634L81.9219 63.7898L81.7515 63.6446H81.7501L80.0537 54.953L80.1221 54.9405L91.0127 52.814L92.7971 61.9523Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M18.1274 25.4697L18.2645 25.4429L19.1439 29.9471L19.0069 29.9739L18.1274 25.4697Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M28.9478 23.3569L29.0848 23.3302L29.9642 27.8344L29.8272 27.8611L28.9478 23.3569Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M39.7705 21.2439L39.9075 21.2171L40.787 25.7213L40.65 25.7481L39.7705 21.2439Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M50.5908 19.1312L50.7279 19.1044L51.6073 23.6086L51.4703 23.6354L50.5908 19.1312Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M61.4136 17.0178L61.5506 16.9911L62.4301 21.4954L62.293 21.5222L61.4136 17.0178Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M72.2339 14.9051L72.3709 14.8783L73.2504 19.3827L73.1134 19.4094L72.2339 14.9051Z",
    fill: "#1D72F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailabilityCalendar);
export default __webpack_public_path__ + "static/media/availability-calendar.8ba61c0c12abf206f22f08c6c32d5b99.svg";
export { ForwardRef as ReactComponent };